/**
 * The lenses as tabs under the map, right above the lens they choose: Records · Runs · Changes · Values. The open one is
 * selected; with none open the row sits under the time bar, ready to open one. Choosing one is a history step (the
 * stage's `set`), so Back returns to the lens before.
 */
import { cx } from '../design/primitives.tsx';
import { LENS_LABEL, LensIcon } from './Answer.tsx';
import { LENSES, type LensId } from './scope.ts';

export function LensTabs({ lens, onLens }: { lens: LensId | null; onLens: (l: LensId) => void }) {
  return (
    <div role="tablist" aria-label="Lenses" data-lens-tabs="" className="flex items-center gap-1 px-1 -mb-1">
      {LENSES.map((l) => {
        const on = lens === l;
        return (
          <button key={l} type="button" role="tab" aria-selected={on} data-lens={l} onClick={() => { if (!on) onLens(l); }}
            className={cx('inline-flex items-center gap-2 h-9 px-3.5 rounded-full border-0 cursor-pointer text-small whitespace-nowrap transition-colors duration-[var(--t-micro)]',
              on ? 'bg-n2 text-n10 font-semibold shadow-[0_1px_2px_rgb(0_0_0/0.08)] ring-1 ring-inset ring-accent/50' : 'bg-transparent text-n8 hover:bg-n3 hover:text-n10')}>
            <span className={on ? 'text-accent' : 'text-n7'}><LensIcon lens={l} /></span>
            {LENS_LABEL[l]}
          </button>
        );
      })}
    </div>
  );
}
